import { createFileRoute } from '@tanstack/react-router'
import { AccountNav } from '@/features/settings/ui/account-nav'
import { Outlet } from '@/libs/router'
import { PageLayout } from '@/components/page-layout'

export const Route = createFileRoute('/_authenticated/account')({
	component: AccountLayout,
})

function AccountLayout() {
	return (
		<PageLayout className='max-w-200'>
			<AccountNav />
			<Outlet />
		</PageLayout>
	)
}
